import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';

import { ICrisisModel, IThunkAddCrisisAllocationManual } from '../types';

const onAddCrisisAllocationManual: IThunkAddCrisisAllocationManual = thunk(
  async (actions: Actions<ICrisisModel>, { clinicId, payload }) => {
    const crisisAllocation = await api.crisis
      .createManualCrisisAllocation(clinicId, payload)
      .then(r => r.data);

    actions.setCrisisAllocation(crisisAllocation);
    await actions.onGetCrisisCalls({ clinicId });

    return crisisAllocation;
  },
);

export default onAddCrisisAllocationManual;
